module.exports = __webpack_public_path__ + "static/media/lock_icon.83c2d844.svg";